export const CLASSIC_PROFILE_ROUTE = '/auth/profile';
export const SLEEP_PROFILE_ROUTE = '/calm-sleep-app/auth/profile';

export const CLASSIC_ACCESS_TOKEN_ROUTE = '/auth/access-token';
export const SLEEP_ACCESS_TOKEN_ROUTE = '/calm-sleep-app/auth/access-token';

export const getProfileRoute = (isCalmSleepApp: boolean): string =>
	isCalmSleepApp ? SLEEP_PROFILE_ROUTE : CLASSIC_PROFILE_ROUTE;
